import React, { useState, useMemo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './BaasHigherSavingsContent.scss';

const pricingData = {
  // iQube variants
  'iQube 2.2 kWh': {
    onRoadPrice: 59999,
    // tenures: {
    //   12: { baasCost: 1800, savings: 22, ownershipSavings: 38000 },
    //   24: { baasCost: 1500, savings: 27, ownershipSavings: 45000 },
    //   36: { baasCost: 1300, savings: 30, ownershipSavings: 52000 },
    // },
    years: 5,
    monthlyRunningCost: 1202,
    savings: 13,
    ownershipSavings: 45280,
    BatteryWarrantyCost: 50000,
    chargingCost: 0,
  },
  'iQube 3.1 kWh': {
    onRoadPrice: 66167,
    // tenures: {
    //   12: { baasCost: 2200, savings: 20, ownershipSavings: 42000 },
    //   24: { baasCost: 1900, savings: 25, ownershipSavings: 52000 },
    //   36: { baasCost: 1700, savings: 28, ownershipSavings: 60000 },
    // },
    years: 5,
    monthlyRunningCost: 1265,
    savings: 31,
    ownershipSavings: 53240,
    BatteryWarrantyCoverage: 70000,
    chargingCost: 0,
  },
  'iQube 3.5 kWh': {
    onRoadPrice: 74314,
    // tenures: {
    //   12: { baasCost: 2400, savings: 21, ownershipSavings: 46000 },
    //   24: { baasCost: 2100, savings: 26, ownershipSavings: 58000 },
    //   36: { baasCost: 1850, savings: 29, ownershipSavings: 65000 },
    // },
    years: 5,
    monthlyRunningCost: 1402,
    savings: 25,
    ownershipSavings: 57087,
    BatteryWarrantyCoverage: 70000,
    chargingCost: 0,
  },
  'iQube S 3.5 kWh': {
    onRoadPrice: 77605,
    // tenures: {
    //   12: { baasCost: 2600, savings: 23, ownershipSavings: 52000 },
    //   24: { baasCost: 2300, savings: 28, ownershipSavings: 64000 },
    //   36: { baasCost: 2000, savings: 32, ownershipSavings: 72000 },
    // },
    years: 5,
    monthlyRunningCost: 1458,
    savings: 23,
    ownershipSavings: 58641,
    BatteryWarrantyCoverage: 70000,
    chargingCost: 0,
  },
  'iQube ST 5.3 kWh': {
    onRoadPrice: 96743,
    // tenures: {
    //   12: { baasCost: 2800, savings: 24, ownershipSavings: 58000 },
    //   24: { baasCost: 2500, savings: 30, ownershipSavings: 72000 },
    //   36: { baasCost: 2200, savings: 35, ownershipSavings: 82000 },
    // },
    years: 5,
    monthlyRunningCost: 1818,
    savings: 7,
    ownershipSavings: 67226,
    BatteryWarrantyCoverage: 70000,
    chargingCost: 0,
  },

  // Orbiter variants
  'Orbiter V1': {
    onRoadPrice: 49999,
    // tenures: {
    //   12: { baasCost: 1600, savings: 18, ownershipSavings: 30000 },
    //   24: { baasCost: 1400, savings: 22, ownershipSavings: 36000 },
    //   36: { baasCost: 1200, savings: 26, ownershipSavings: 42000 },
    // },
    years: 3,
    monthlyRunningCost: 862,
    savings: 39,
    ownershipSavings: 43388,
    BatteryWarrantyCoverage: 30000,
    chargingCost: 0,
  },
  'Orbiter V2': {
    onRoadPrice: 59664,
    // tenures: {
    //   12: { baasCost: 1800, savings: 18429, ownershipSavings: 32000 },
    //   24: { baasCost: 1600, savings: 23, ownershipSavings: 38000 },
    //   36: { baasCost: 1400, savings: 27, ownershipSavings: 44000 },
    // },
    years: 5,
    monthlyRunningCost: 1155,
    savings: 41,
    ownershipSavings: 51850,
    BatteryWarrantyCoverage: 70000,
    chargingCost: 0,
  },
};

const products = {
  'iqube-baas': [
    'iQube 2.2 kWh',
    'iQube 3.1 kWh',
    'iQube 3.5 kWh',
    'iQube S 3.5 kWh',
    'iQube ST 5.3 kWh',
  ],
  'orbiter-baas': ['Orbiter V1', 'Orbiter V2'],
};

const formatNumberWithSpace = (num) => num.toLocaleString('en-IN').replace(/,/g, ' ');

const BaasHigherSavingsContent = () => {
  const location = useLocation();
  const isOrbiter = location.pathname.toLowerCase().includes('orbiter-baas');
  const buttonText = isOrbiter ? 'Reserve Now' : 'Book Now';
  const buttonUrl = isOrbiter
    ? '/electric-scooters/tvs-orbiter/online-booking'
    : '/electric-scooters/tvs-iqube/online-booking';
  const [variant, setVariant] = useState('');
  const [tenure, setTenure] = useState(24);
  const [availableVariants, setAvailableVariants] = useState([]);

  useEffect(() => {
    // Determine product from URL
    const path = location.pathname.toLowerCase();
    if (path.includes('orbiter-baas')) {
      setAvailableVariants(products['orbiter-baas']);
      setVariant(products['orbiter-baas'][0]);
    } else if (path.includes('iqube-baas')) {
      setAvailableVariants(products['iqube-baas']);
      setVariant(products['iqube-baas'][0]);
    }
  }, [location.pathname]);

  const computedData = useMemo(() => {
    if (!variant) return {};
    const variantData = pricingData[variant];
    return {
      onRoadPrice: variantData.onRoadPrice,
      years: variantData.years,
      monthlyRunningCost: variantData.monthlyRunningCost,
      BatteryWarrantyCoverage:
        variantData.BatteryWarrantyCoverage || variantData.BatteryWarrantyCost,
      chargingCost: variantData.chargingCost,
      savings: variantData.savings,
      ownershipSavings: variantData.ownershipSavings,
    };
  }, [variant]);

  if (!variant) return null; // or a loader

  return (
    <section className="higher-section">
      <div className="baas-higher-savings-content-container">
        <h1 className="title">Higher Savings</h1>
        <p className="subtitle">Ride Smart. Save Big. Repeat</p>

        <div className="variant-flex">
          {/* Variant Selector */}
          <div className="field">
            <div className={`floating-field ${variant ? 'active' : ''}`}>
              <select value={variant} onChange={(e) => setVariant(e.target.value)}>
                {availableVariants.map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
              <label>Select Variant</label>
            </div>
          </div>

          {/* Tenure Selector */}
          {/* <div className="field">
            <div className={`floating-field ${tenure ? 'active' : ''}`}>
              <select value={tenure} onChange={(e) => setTenure(Number(e.target.value))}>
                <option value={12}>12 Months</option>
                <option value={24}>24 Months</option>
                <option value={36}>36 Months</option>
              </select>
              <label>Subscription Tenure</label>
            </div>
          </div> */}
        </div>

        {/* Computed Data Display */}
        <div className="higher-container">
          <div className="higher-content-inner">
            <div className="higher-list">
              <div className="higher-list-line">
                <ul>
                  <li>Effective Ex showroom with BaaS*</li>
                  <li>₹ {formatNumberWithSpace(computedData.onRoadPrice)}</li>
                </ul>
                <ul>
                  <li className="font-24">
                    Monthly Payment Cost
                    <span className="d-block font-12">
                      Available in tenures of 24/36/60 months*
                    </span>
                  </li>
                  <li className="font-24">
                    ₹ {formatNumberWithSpace(computedData.monthlyRunningCost)}
                  </li>
                </ul>
                <ul>
                  <li>Battery Warranty Coverage</li>
                  <li>
                    {formatNumberWithSpace(computedData.years)} Years/
                    {formatNumberWithSpace(computedData.BatteryWarrantyCoverage)} km
                  </li>
                </ul>
                <ul>
                  <li>Monthly Kms Usage</li>
                  <li>Unlimited</li>
                </ul>
                <ul>
                  <li className="font-color-green">Savings</li>
                  <li className="font-color-green">
                    {formatNumberWithSpace(computedData.savings)}%
                  </li>
                </ul>
              </div>
              <div className="higher-list-line bg">
                <ul>
                  <li className="font-24">
                    Baas Ownership Savings
                    <span className="d-block font-12">
                      1st year of ownership savings, inclusive of running cost & vehicle price
                    </span>
                  </li>
                  <li className="font-28 font-weight-600">
                    ₹ {formatNumberWithSpace(computedData.ownershipSavings)}*
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="disclaimer">
          <p>
            Disclaimer: Savings are calculated in comparison with a petrol scooter, considering both
            scooter cost and running cost.
          </p>
          <a href={buttonUrl} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            {buttonText}
          </a>
        </div>
      </div>
    </section>
  );
};

export default React.memo(BaasHigherSavingsContent);
